import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { Button, Grid, TextField } from '@material-ui/core'
import { BasePhoneInput } from 'components'

import { Controller, useForm } from 'react-hook-form'
import useJourneyWhiteLabel from 'hooks/useJourneyWhiteLabel'
import useSnackbar from 'hooks/useSnackbar'
import useGovernanceProjectNameDpo from 'hooks/useGovernanceProjectNameDpo'

import * as service from 'service'
import helpers from 'helpers'

import constants from 'constants/index'

import schema from './schema'

const PrincipalDpoName = () => {
  const snackbar = useSnackbar()
  const { setCurrentStep } = useJourneyWhiteLabel()
  const {
    governanceProjectTemplate,
    governanceProjectCompany,
    dpoKind,
    setDpoKind,
    principalDpo,
    setPrincipalDpo,
  } = useGovernanceProjectNameDpo()

  const isInternalDpo =
    dpoKind === constants.governanceProjectStages.INTERNAL_KIND_DPO
  const isExternalDpo =
    dpoKind === constants.governanceProjectStages.EXTERNAL_KIND_DPO

  const { control, handleSubmit, errors } = useForm({
    validationSchema: schema(isInternalDpo),
    defaultValues: {
      sectionName: principalDpo?.sectionName || '',
      sectionDocument: principalDpo?.sectionDocument || '',
      sectionResponsibleName: principalDpo?.sectionResponsibleName || '',
      email: principalDpo?.email || '',
      phone: principalDpo?.phone || '',
      phone2: principalDpo?.phone2 || '',
      addressLine: principalDpo?.addressLine || '',
    },
  })

  const onSubmit = async (data) => {
    try {
      await service.dponet.governanceProjectStage.nameDpo({
        token: governanceProjectTemplate?.token,
        companyDocument: helpers.regex.onlyNumbersAndLetters(
          governanceProjectCompany?.company?.document,
        ),
        governanceProjectTemplateStage: {
          ...data,
          kind: dpoKind,
        },
      })

      setPrincipalDpo({ ...data, kind: dpoKind })
      setCurrentStep((prevStep) => prevStep + 1)
    } catch (error) {
      console.error('Error submitting form:', error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    }
  }

  const handleChangeCnpj́ = ([event]) => {
    event.target.value = helpers.formatters.cnpj(event.target.value)

    return event
  }

  const handleChangeKind = (kind) => () => {
    setDpoKind(kind)
  }

  return (
    <PerfectScrollbar
      options={{
        suppressScrollX: true,
        suppressScrollY: true,
        wheelPropagation: true,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Button
            fullWidth
            color="primary"
            variant={isInternalDpo ? 'contained' : 'outlined'}
            onClick={handleChangeKind('internal_dpo')}
          >
            Encarregado Interno
          </Button>
        </Grid>
        <Grid item xs={12} md={6}>
          <Button
            fullWidth
            color="primary"
            variant={isExternalDpo ? 'contained' : 'outlined'}
            onClick={handleChangeKind('external_dpo')}
          >
            Encarregado Externo
          </Button>
        </Grid>
        {!!dpoKind && (
          <Grid item xs={12}>
            <form id="name-dpo-form" onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={2}>
                {isInternalDpo && (
                  <Grid item xs={12} md={6}>
                    <Controller
                      as={
                        <TextField
                          fullWidth
                          error={errors?.sectionResponsibleName}
                          helperText={errors?.sectionResponsibleName?.message}
                          label="Nome completo"
                        />
                      }
                      control={control}
                      name="sectionResponsibleName"
                    />
                  </Grid>
                )}
                <Grid item xs={12} md={6}>
                  <Controller
                    as={
                      <TextField
                        fullWidth
                        error={errors?.sectionName}
                        helperText={errors?.sectionName?.message}
                        label={
                          isInternalDpo ? 'Departamento' : 'Nome da Empresa'
                        }
                      />
                    }
                    control={control}
                    name="sectionName"
                  />
                </Grid>
                {isExternalDpo && (
                  <Grid item xs={12} md={6}>
                    <Controller
                      as={
                        <TextField
                          fullWidth
                          error={errors?.sectionDocument}
                          helperText={errors?.sectionDocument?.message}
                          label="CNPJ da Empresa"
                        />
                      }
                      onChange={handleChangeCnpj́}
                      control={control}
                      name="sectionDocument"
                    />
                  </Grid>
                )}
                {isExternalDpo && (
                  <Grid item xs={12} md={6}>
                    <Controller
                      as={
                        <TextField
                          fullWidth
                          error={errors?.sectionResponsibleName}
                          helperText={errors?.sectionResponsibleName?.message}
                          label="Nome do Responsável Técnico"
                        />
                      }
                      name="sectionResponsibleName"
                      control={control}
                    />
                  </Grid>
                )}
                <Grid item xs={12} md={isInternalDpo ? 12 : 6}>
                  <Controller
                    as={
                      <TextField
                        fullWidth
                        error={errors?.email}
                        helperText={errors?.email?.message}
                        type="email"
                        label="E-mail"
                      />
                    }
                    name="email"
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Controller
                    as={
                      <BasePhoneInput
                        fullWidth
                        error={errors?.phone}
                        helperText={errors?.phone?.message}
                        label="Telefone Celular"
                      />
                    }
                    control={control}
                    name="phone"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Controller
                    as={
                      <BasePhoneInput
                        fullWidth
                        error={errors?.phone2}
                        helperText={errors?.phone2?.message}
                        label="Telefone Fixo"
                      />
                    }
                    name="phone2"
                    control={control}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    as={
                      <TextField
                        fullWidth
                        error={errors?.addressLine}
                        helperText={errors?.addressLine?.message}
                        label="Endereço"
                      />
                    }
                    control={control}
                    name="addressLine"
                  />
                </Grid>
              </Grid>
            </form>
          </Grid>
        )}
      </Grid>
    </PerfectScrollbar>
  )
}

export default PrincipalDpoName
